var _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxPreLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_59_3393",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V20H8C3.58172 20 0 16.4183 0 12V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30H0ZM30 22H8C2.47715 22 -2 17.5228 -2 12H2C2 15.3137 4.68629 18 8 18H30V22ZM8 22C2.47715 22 -2 17.5228 -2 12V0H2V12C2 15.3137 4.68629 18 8 18V22ZM30 0V20V0Z",
    fill: "#404163",
    fillOpacity: 0.2,
    mask: "url(#path-1-inside-1_59_3393)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxPreLine);
export default __webpack_public_path__ + "static/media/CheckboxPreLine.b1fe09a693bd3f7142e28db7f40b2bcb.svg";
export { ForwardRef as ReactComponent };